import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';
import { LayoutService } from '../../../@core/utils';
import { HttpService } from '../../../shared/services/http/http-client.service';


@Injectable({
  providedIn: 'root'
})
export class OneColumnService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  travelBalanceStatement(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/enterprise/travel/travelBalanceStatement', data, successHandle, errorHandle);

 }

}
